<template>
  <div class="advert card" :style="style" v-if="advert.link">
      <a :href="advert.link" :target="advert.target" v-html="advert.text"></a>
  </div>
  <div class="advert card" :style="style" v-else>
      <a :target="advert.target" v-html="advert.text"></a>
  </div>
</template>

<script>
export default {
  props: {
    advert: {
      required: true
    }
  },
  computed: {
    style () {
      return {
        'background-image': this.advert.image ? `url(https://svetmetraze.si${this.advert.image})` : false,
        'background-color': this.advert.background_color || false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.advert.card {
  min-height: 280px;
  padding: 2rem 1.25rem 2.5rem;
  position: relative;

  > a {
    color: white;
    text-align: center;
    font-size: 1.125rem;
    text-decoration: none;
    padding: 15px;

    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
}
</style>
